import React, { useState, useEffect, useRef, useCallback } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Document, Page, pdfjs } from "react-pdf";
import { AiOutlineDownload } from "react-icons/ai";
import { BiLinkExternal } from "react-icons/bi";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import pdf from "../../Assets/AzkaBashirResume.pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

function ResumeNew() {
  const viewerRef = useRef(null);
  const pageRefs = useRef([]);

  const [numPages, setNumPages] = useState(null);
  const [pageWidth, setPageWidth] = useState(720);
  const [activePage, setActivePage] = useState(1);

  const updatePageWidth = useCallback(() => {
    if (!viewerRef.current) return;
    const containerWidth = viewerRef.current.offsetWidth;
    const horizontalPadding = containerWidth < 480 ? 24 : containerWidth < 768 ? 32 : 48;
    setPageWidth(Math.min(820, containerWidth - horizontalPadding));
  }, []);

  useEffect(() => {
    updatePageWidth();
    window.addEventListener("resize", updatePageWidth);
    return () => window.removeEventListener("resize", updatePageWidth);
  }, [updatePageWidth]);

  const onDocumentLoadSuccess = ({ numPages: totalPages }) => {
    setNumPages(totalPages);
    pageRefs.current = Array(totalPages).fill(null);
  };

  const scrollToPage = (pageNumber) => {
    const pageEl = pageRefs.current[pageNumber - 1];
    if (pageEl) {
      pageEl.scrollIntoView({ behavior: "smooth", block: "start" });
      setActivePage(pageNumber);
    }
  };

  return (
    <Container fluid className="resume-section">
      <Container>
        <Row className="resume-hero">
          <Col xs={12} className="resume-hero-content">
            <h1 className="resume-main-heading">
              My <strong className="purple">Resume</strong>
            </h1>
            <p className="resume-intro">
              Full-stack JavaScript developer—React, Next.js, Vue.js, React Native,
              Node.js & Express. Browse both pages below or download for offline viewing.
            </p>
            <div className="resume-actions">
              <Button
                variant="primary"
                href={pdf}
                download="Azka-Bashir-Resume.pdf"
                className="download-button resume-action-btn"
              >
                <AiOutlineDownload />
                &nbsp;Download Resume
              </Button>
              <Button
                variant="outline-primary"
                href={pdf}
                target="_blank"
                rel="noreferrer"
                className="resume-action-btn"
              >
                <BiLinkExternal />
                &nbsp;Open in new tab
              </Button>
            </div>
          </Col>
        </Row>

        {numPages > 1 && (
          <Row className="resume-page-nav-row">
            <Col xs={12}>
              <div className="resume-page-nav">
                <span className="resume-page-label">
                  {numPages} pages
                </span>
                {Array.from({ length: numPages }, (_, index) => {
                  const pageNumber = index + 1;
                  return (
                    <button
                      key={pageNumber}
                      type="button"
                      className={`resume-page-btn${activePage === pageNumber ? " active" : ""}`}
                      onClick={() => scrollToPage(pageNumber)}
                    >
                      Page {pageNumber}
                    </button>
                  );
                })}
              </div>
            </Col>
          </Row>
        )}

        <Row className="resume-viewer-row">
          <Col xs={12}>
            <div className="resume-viewer" ref={viewerRef}>
              <Document
                file={pdf}
                onLoadSuccess={onDocumentLoadSuccess}
                loading={
                  <div className="resume-loading">
                    <Loader type="TailSpin" color="#623686" height={48} width={48} />
                    <p>Loading resume…</p>
                  </div>
                }
                error={
                  <div className="resume-error">
                    <p>Unable to load the resume. Please use the download button instead.</p>
                  </div>
                }
              >
                {numPages &&
                  Array.from({ length: numPages }, (_, index) => {
                    const pageNumber = index + 1;
                    return (
                      <div
                        key={pageNumber}
                        className="resume-page-wrap"
                        ref={(el) => {
                          pageRefs.current[index] = el;
                        }}
                      >
                        {numPages > 1 && (
                          <span className="resume-page-badge">
                            Page {pageNumber} of {numPages}
                          </span>
                        )}
                        <Page
                          pageNumber={pageNumber}
                          width={pageWidth}
                          renderTextLayer={false}
                          className="resume-pdf-page"
                        />
                      </div>
                    );
                  })}
              </Document>
            </div>
          </Col>
        </Row>

        <Row className="resume-footer-actions">
          <Col xs={12}>
            <Button
              variant="primary"
              href={pdf}
              download="Azka-Bashir-Resume.pdf"
              className="download-button resume-action-btn"
            >
              <AiOutlineDownload />
              &nbsp;Download Resume
            </Button>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default ResumeNew;
